<template>
  <div class="container-slider-map">
    <div
      class="container-slider-map__button container-slider-map__button--top"
      @click="addValue"
    >
      <span class="material-icons">
        add
      </span>
    </div>
    <Slider
      v-model="valueComputed"
      orientation="vertical"
      :step="1"
      :max="props___.maxValue"
      :min="props___.minValue"
    />

    <div class="container-slider-map__button container-slider-map__button--bottom">
      <span
        class="material-icons"
        @click="subtractValue"
      >
        remove
      </span>
    </div>
  </div>
</template>


<script setup>
import Slider from 'primevue/slider';
import {computed} from 'vue';

// #region Props, Emits
const props___ = defineProps({
  value: {
    type: Number,
    default: null,
  },
  minValue: {
    type: Number,
    default: 2,
  },
  maxValue: {
    type: Number,
    default: 20,
  },
});

const emits = defineEmits(['change']);
// #endregion


// #region Params, Ref, Reactives, Computed
const valueComputed = computed({
  get: () => props___.value,
  set: (value) => {
    emits('change', value);
  },
});
// #endregion


// #region Functions
function addValue() {
  const newValue = props___.value + 1;
  if (newValue <= props___.maxValue) {
    emits('change', newValue);
  }
}
function subtractValue() {
  const newValue = props___.value - 1;
  if (newValue >= props___.minValue) {
    emits('change', newValue);
  }
}
// #endregion


// #region Effects, Hooks
// ...
// #endregion


// #region Provide, Expose
// ...
// #endregion
</script>


<style lang="scss" scoped>
.container-slider-map {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__button {
    border: 2px solid rgba($brand__color--grey, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba($brand__color--blue, 0.8);
    color: $brand__color--white;
    transition: all linear 0.15s;
    cursor: pointer;
    width: 100%;

    &--top {
      margin-bottom: 5px;
    }

    &--bottom {
      margin-top: 5px;
    }

    &:hover {
      border-color: $brand__color--grey;
      background-color: $brand__color--blue;
    }
  }

  & :deep(.p-slider) {
    width: 100%;
    cursor: pointer;

    & .p-slider-range {
      background: rgba($brand__color--blue, 0.8);
      transition: all linear 0.15s;
    }

    & .p-slider-handle  {
      border-color: rgba($brand__color--blue, 0.8);
    }

    &:hover {
      .p-slider-range{
        background: $brand__color--blue;
      }
      & .p-slider-handle  {
        border-color: $brand__color--blue;
      }
    }
  }
}
</style>
